import React from "react";
import FormikCheckBox, {IFormikCheckBoxProps} from "../formikCheckBox/FormikCheckBox";

interface INewsLettersCheckboxProps extends Partial<IFormikCheckBoxProps> {

}


const NewsLettersCheckbox = (props: INewsLettersCheckboxProps) => {
  return <FormikCheckBox
    name="allowAdvertisementEmails"
    label={'אני מעוניין/ת לקבל הודעות שיווקיות מדיל אנד גו'}
  />;
};

NewsLettersCheckbox.defaultProps = {};

export default React.memo(NewsLettersCheckbox);
